import { theme as defaultTheme, Icon } from "@mindlercare/ui-web";
import { Box } from "@mui/material";

type ResultProps = {
  successs: boolean;
  informationText?: string;
};

export const Result = (props: ResultProps) => {
  return (
    <Box sx={{ marginTop: "24px", display: "flex", alignItems: "center" }}>
      <Box
        sx={{
          width: "105px",
          height: "8px",
          borderRadius: "100px",
          bgcolor: props.successs
            ? defaultTheme.COLORS.PRIMARY
            : defaultTheme.COLORS.GRAY_MEDIUM,
        }}
      ></Box>
      <Box sx={{ marginLeft: "10px", display: "flex", alignItems: "center" }}>
        {props.successs && <Icon.Done />}
        {!props.successs && <Icon.Close />}
      </Box>
    </Box>
  );
};
